import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { PoLookupColumn, PoLookupLiterals, PoLookupFilter, PoNotificationService, PoLookupComponent } from '@po-ui/ng-components';
import { GenericResultsApi } from 'src/service/apis-cockpit';
import { InputItem } from '../inputcommon/inputcommon.class';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { InputLookupService } from '../inputcharts/inputservices/inputlookup.service';
import { PageBase } from 'src/app/shared/library/page.base';
import { InputTasksService } from '../inputtasks/inputtasks.service';

@Component({
    selector: 'cp-input-board',
    templateUrl: './inputboard.component.html',
    styleUrls: ['./inputboard.component.css'],
    standalone: false
})

export class InputBoardComponent extends PageBase implements OnInit {

  @ViewChild('lookupInsumos', { static: true }) lookupInsumos: PoLookupComponent; // Acesso do lookup para outros componentes

  columnsName: Array<string>;
  columns: Array<PoLookupColumn>;
  event: string;
  fieldLabel: string;
  fieldValue: string;
  filterService: PoLookupFilter | string;
  label: string;
  help: string;
  customLiterals: PoLookupLiterals;
  literals: string;
  properties: Array<string>;
  inputInfo = new InputItem();

  constructor(private inputTaskService: InputTasksService,
              public poNotification: PoNotificationService,
              public inputLookupService: InputLookupService,
              public contextApplication: ContextApplication,
              public objInjector: Injector)
  {
    super(objInjector);
  }
  public readonly columnsDefinition = {
    label: { property: 'inputCode', label: 'Cod.Insumo', width: '20%', fieldLabel: true } as PoLookupColumn,
    value: { property: 'description', label: 'Descrição', fieldLabel: true } as PoLookupColumn,
    desc: { property: 'unitCode', label: 'Unidade', width: '30%' } as PoLookupColumn,
  };

  ngOnInit(): void {
    super.ngOnInit();
    this.restore();
  }

  changeEvent(event: any) {
    if (event) {
      this.inputLookupService.IsSearching = false;
      if (event['$selected']) {
        this.InsertInfoInput(event);
      }
      else {
        const item = event as GenericResultsApi;
        if(item.items.length > 0){
          this.InsertInfoInput(event['items'][0]);
        }
        else{
          this.poNotification.warning('Insumo não encontrado.');
        }
      }
    }
  }

  private InsertInfoInput(input: any) {
    this.inputInfo = new InputItem();
    this.inputInfo.companyid = input['companyId'];
    this.inputInfo.description = input['description'];
    this.inputInfo.inputCode = input['inputCode'];
    this.inputInfo.inputId = input['inputId'];
    this.inputInfo.projectid = input['projectId'];
    this.inputInfo.unitCode = input['unitCode'];
    this.inputInfo.inputTypeHiring = input['inputTypeHiring'];
    this.contextApplication.hiddenDashboardTaskInput[1] = false;
  }

  public RefreshData(){
    if (this.inputInfo && this.inputInfo.inputId){
      this.inputTaskService.ResetPages();
      this.inputTaskService.GetInput(this.inputInfo).then(
        result => {
          if (result && result.items.length > 0){
            const newInputInfo = {companyId: -1, description: '', inputCode: '', inputId: -1, projectId: -1,
                                  unitCode: '', inputTypeHiring: -1};
            newInputInfo.companyId = this.inputInfo.companyid;
            newInputInfo.description = result.items[0]['description'];
            newInputInfo.inputCode = result.items[0].inputCode;
            newInputInfo.inputId = this.inputInfo.inputId;
            newInputInfo.projectId = this.inputInfo.projectid;
            newInputInfo.unitCode = result.items[0].unitCode;
            newInputInfo.inputTypeHiring = this.inputInfo.inputTypeHiring;
            this.InsertInfoInput(newInputInfo);
          }
        }
      );
    }
  }

  fieldFormat(obj: any) {
    if (!obj || obj === undefined) {
      return '';
    }
    else {
      if (obj.items) {
        const inputs = obj as GenericResultsApi;
        return inputs.items.length > 0 ? `${inputs.items[0].inputCode} - ${inputs.items[0].description}`: '';
      }
      else {
        return `${obj['inputCode']} - ${obj['description']}`;
      }
    }
  }

  changeLiterals() {
    try {
      this.customLiterals = JSON.parse(this.literals);
    } catch {
      this.customLiterals = undefined;
    }
  }

  restore() {
    this.columnsName = ['label', 'value', 'desc'];
    this.updateColumns();
    this.fieldLabel = 'description';
    this.fieldValue = 'description';
    this.event = undefined;
    this.filterService = undefined;
    this.label = 'Insumo';
    this.help = undefined;
    this.literals = undefined;
    this.properties = [];
  }

  updateColumns() {
    this.columns = [];
    this.columnsName.forEach(column => this.columns.push(this.columnsDefinition[column]));
  }

  onReceiveLiterals() {}

}
